export const EDGE_INPUT_SLOT_META = {
    source: {
        key: 'source',
        label: '源素材',
    },
    reference: {
        key: 'reference',
        label: '参考图',
    },
    commodity: {
        key: 'commodity',
        label: '商品图',
    },
    match: {
        key: 'match',
        label: '搭配图',
    },
    otherView1: {
        key: 'otherView1',
        label: '其他视角1',
    },
    otherView2: {
        key: 'otherView2',
        label: '其他视角2',
    },
};

export const FUNCTION_NODE_EDGE_SLOT_LABEL_OVERRIDES = {
    templateReplace: {
        reference: '参考图',
        source: '模特图',
    },
    imageUpscale: {
        source: '输入图',
    },
    materialHD: {
        source: '面料平铺图',
        reference: '模特/服装图',
    },
    creativeColor: {
        source: '模特图',
        reference: '参考模特图',
    },
    skinHD: {
        source: '源素材',
    },
};

export const FUNCTION_NODE_EDGE_SLOT_KEYS = {
    templateReplace: ['source', 'reference'],
    templateReplaceExpt: ['source', 'reference', 'match'],
    materialHD: ['source', 'reference'],
    faceSwap: ['source', 'reference'],
    skinHD: ['source'],
    imageUpscale: ['source'],
    shoesTryon: ['source', 'reference', 'otherView1', 'otherView2'],
    shoesRefiner: ['source', 'commodity', 'otherView1', 'otherView2'],
    repose: ['source', 'reference'],
    relight: ['source', 'reference', 'match'],
    creativeColor: ['source', 'reference'],
};

const getNormalizedSlotKeys = (slotKeys = []) => slotKeys.filter((slotKey) => EDGE_INPUT_SLOT_META[slotKey]);

const getRelightMode = (nodeLike) => {
    const data = nodeLike?.data && typeof nodeLike.data === 'object'
        ? nodeLike.data
        : (nodeLike && typeof nodeLike === 'object' ? nodeLike : {});
    const panelState = data?.panelState && typeof data.panelState === 'object' ? data.panelState : {};
    const inputParams = data?.inputParams && typeof data.inputParams === 'object' ? data.inputParams : {};

    return panelState.mode
        || panelState?.extraSelectValues?.mode
        || inputParams.mode
        || 'single';
};

export const getFunctionNodeEdgeSlotKeys = (functionKey, nodeLike = null) => {
    if (functionKey === 'relight') {
        const relightMode = getRelightMode(nodeLike);
        return getNormalizedSlotKeys(relightMode === 'suit'
            ? ['source', 'reference', 'match']
            : ['source', 'reference']);
    }

    return getNormalizedSlotKeys(FUNCTION_NODE_EDGE_SLOT_KEYS[functionKey] || []);
};

export const getFunctionNodeEdgeSlotOptions = (functionKey, nodeLike = null) => (
    getFunctionNodeEdgeSlotKeys(functionKey, nodeLike).map((slotKey) => ({
        ...EDGE_INPUT_SLOT_META[slotKey],
        label: FUNCTION_NODE_EDGE_SLOT_LABEL_OVERRIDES[functionKey]?.[slotKey]
            || EDGE_INPUT_SLOT_META[slotKey]?.label
            || '',
    }))
);

export const getNextAvailableEdgeSlotKey = ({ edges = [], targetId, slotKeys = [], excludeEdgeId = null }) => {
    const normalizedSlotKeys = getNormalizedSlotKeys(slotKeys);
    if (normalizedSlotKeys.length === 0) return null;

    const usedSlotKeys = new Set(
        edges
            .filter((edge) => edge.target === targetId && edge.id !== excludeEdgeId)
            .map((edge) => edge.data?.inputSlotKey)
            .filter((slotKey) => normalizedSlotKeys.includes(slotKey)),
    );

    return normalizedSlotKeys.find((slotKey) => !usedSlotKeys.has(slotKey)) || normalizedSlotKeys[0];
};

export const reconcileEdgeSlotAssignment = ({
    edges = [],
    edgeId,
    targetId,
    slotKeys = [],
    preferredSlotKey = null,
}) => {
    const normalizedSlotKeys = getNormalizedSlotKeys(slotKeys);
    if (normalizedSlotKeys.length === 0) return edges;

    const currentEdge = edges.find((edge) => edge.id === edgeId && edge.target === targetId);
    if (!currentEdge) return edges;

    const currentSlotKey = normalizedSlotKeys.includes(currentEdge.data?.inputSlotKey)
        ? currentEdge.data.inputSlotKey
        : null;
    const nextSlotKey = normalizedSlotKeys.includes(preferredSlotKey)
        ? preferredSlotKey
        : getNextAvailableEdgeSlotKey({
            edges,
            targetId,
            slotKeys: normalizedSlotKeys,
            excludeEdgeId: edgeId,
        });

    if (!nextSlotKey) return edges;

    const targetEdges = edges.filter((edge) => edge.target === targetId);
    const conflictingEdge = targetEdges.find((edge) => (
        edge.id !== edgeId && edge.data?.inputSlotKey === nextSlotKey
    ));

    let conflictingNextSlotKey = null;

    if (conflictingEdge) {
        const occupiedSlotKeys = new Set(
            targetEdges
                .filter((edge) => edge.id !== edgeId && edge.id !== conflictingEdge.id)
                .map((edge) => edge.data?.inputSlotKey)
                .filter((slotKey) => normalizedSlotKeys.includes(slotKey)),
        );

        if (currentSlotKey && currentSlotKey !== nextSlotKey && !occupiedSlotKeys.has(currentSlotKey)) {
            conflictingNextSlotKey = currentSlotKey;
        } else {
            conflictingNextSlotKey = normalizedSlotKeys.find((slotKey) => (
                slotKey !== nextSlotKey && !occupiedSlotKeys.has(slotKey)
            )) || null;
        }
    }

    return edges.map((edge) => {
        if (edge.id === edgeId) {
            return {
                ...edge,
                data: {
                    ...edge.data,
                    inputSlotKey: nextSlotKey,
                },
            };
        }

        if (conflictingEdge && edge.id === conflictingEdge.id && conflictingNextSlotKey) {
            return {
                ...edge,
                data: {
                    ...edge.data,
                    inputSlotKey: conflictingNextSlotKey,
                },
            };
        }

        return edge;
    });
};
